import { render } from "./HeroBackgroundPhoto.vue?vue&type=template&id=6a6c2e93&ts=true"
import script from "./HeroBackgroundPhoto.vue?vue&type=script&lang=ts"
export * from "./HeroBackgroundPhoto.vue?vue&type=script&lang=ts"

import "./HeroBackgroundPhoto.vue?vue&type=style&index=0&id=6a6c2e93&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__